<template>
  <el-dialog
    :title="pageConfigType === 'create' ? '新增' : '编辑'"
    :visible.sync="addSituationSolutionVisible"
    class="small-dialog"
    v-dialogDrag
    :before-close="cancel"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form
      ref="addSituationSolutionRef"
      label-width="150px"
      :model="addSituationSolutionForm"
      class="clear-placeholer"
    >
      <el-form-item
        label="预案名称"
        prop="emergencyPlanId"
        :rules="[
          {
            required: true,
            message: '请选择预案名称',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-select
          v-model="addSituationSolutionForm.emergencyPlanId"
          size="small"
          placeholder="请选择"
          clearable
          filterable
          @change="getPlanItem"
          :disabled="pageConfigType === 'read'"
        >
          <el-option
            v-for="item in planList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            :disabled="item.disabled"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="预案编辑时间"
        prop="publishedTime"
        :rules="[
          {
            required: true,
            message: '请选择预案编辑时间',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-date-picker
          size="small"
          v-model="addSituationSolutionForm.publishedTime"
          type="datetime"
          placeholder="请选择预案编辑时间"
          clearable
          disabled
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="预案演练时间"
        prop="exerciseTime"
        :rules="[
          {
            required: true,
            message: '请选择预案演练时间',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-date-picker
          size="small"
          v-model="addSituationSolutionForm.exerciseTime"
          type="datetime"
          placeholder="请选择预案演练时间"
          clearable
          :disabled="pageConfigType === 'read'"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item
        label="预案演练评价"
        prop="evaluation"
        :rules="[
          {
            required: true,
            message: '请输入预案演练评价',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          v-model="addSituationSolutionForm.evaluation"
          maxlength="50"
          type="textarea"
          rows="3"
          placeholder="请输入预案演练评价"
          :disabled="pageConfigType === 'read'"
        />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="addSituationSolutionForm.remark"
          maxlength="50"
          type="textarea"
          rows="3"
          placeholder="请输入备注"
          :disabled="pageConfigType === 'read'"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="flex justify-center">
      <el-button size="small" type="primary" @click="save" :loading="loading">保存</el-button>
      <el-button size="small" @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import clearPlaceholder from '@/assets/js/safety/ClearPlaceholder'
import { ContractorApi } from '@wiz-api/contractor-management'
import dayjs from 'dayjs'
import { PlanApi } from '@wiz-api/emergency-management'

const contractorApi = new ContractorApi()
const planApi = new PlanApi()
export default {
  model: {
    prop: 'addSituationSolutionVisible',
    event: 'addSituationSolutionChange',
  },
  props: {
    addSituationSolutionVisible: {
      type: Boolean,
      default: false,
    },
    contractorId: {
      type: String,
      default: '',
    },

    saveRow: {
      type: Object,
      default: () => {},
    },
    pageConfigType: {
      type: String,
      default: 'create',
    },
  },
  data() {
    return {
      planList: [],
      title: '新增',
      loading: false,
      addSituationSolutionForm: {
        remark: '',
      },
      taskFrequencyType: [],
      workPermitCategoryList: [],
    }
  },
  watch: {
    // saveRow(val) {
    //   if (val.id) {
    //     this.addSituationSolutionForm = val
    //     if (this.pageConfigType === 'read') {
    //       clearPlaceholder('.clear-placeholer')
    //     }
    //   }
    // },
    'addSituationSolutionForm.emergencyPlanId': {
      handler(val) {
        if (val === '') {
          this.getPlanItem(val)
        }
      },
    },
  },
  created() {
    this.getPlanList(4)
    this.getPlanList(5)
    if (this.saveRow.id) {
      this.addSituationSolutionForm = this.saveRow
      if (this.pageConfigType === 'read') {
        clearPlaceholder('.clear-placeholer')
      }
    }
  },
  methods: {
    getPlanItem(val) {
      this.addSituationSolutionForm.emergencyPlanId = val
      if (val) {
        this.planList.forEach((item) => {
          if (item.id === val) {
            this.addSituationSolutionForm.emergencyPlanName = item.name
            this.addSituationSolutionForm.publishedTime = dayjs(item.publishDate).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
        })
      } else {
        this.addSituationSolutionForm.emergencyPlanName = ''
        this.addSituationSolutionForm.publishedTime = ''
      }
    },
    async getPlanList(status) {
      const params = {
        maxResultCount: 999,
        skipCount: 0,
        typeName: '现场处置方案',
        status,
      }
      const [
        emergencyPlanErr,
        emergencyRes,
      ] = await contractorApi.getEmergencyPlanIdsInOnSiteDisposalPlanOnSiteDisposalPlan(
        this.contractorId
      )
      if (!emergencyPlanErr) {
        const [err, res] = await planApi.getList(params)
        if (!err) {
          res.items.map((item) => {
            if (emergencyRes.includes(item.id)) {
              item.disabled = true
            } else {
              item.disabled = false
            }
            // 编辑的时候可以选择
            if (this.pageConfigType === 'edit' && item.id === this.saveRow.emergencyPlanId) {
              item.disabled = false
            }
            this.planList.push(item)
          })
        }
      }
    },
    fileIdChange(key) {
      this.$refs[key].$emit('el.form.change')
    },
    cancel() {
      this.addSituationSolutionForm = {}
      this.$refs.addSituationSolutionRef.resetFields()
      this.$emit('addSituationSolutionChange', false)
    },
    save() {
      this.$refs.addSituationSolutionRef.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.addSituationSolutionForm.publishedTime = dayjs(
            this.addSituationSolutionForm.publishedTime
          ).format('YYYY-MM-DD HH:mm:ss')
          this.addSituationSolutionForm.exerciseTime = dayjs(
            this.addSituationSolutionForm.exerciseTime
          ).format('YYYY-MM-DD HH:mm:ss')
          this.addSituationSolutionForm.remark = this.addSituationSolutionForm.remark || ''
          if (!this.saveRow.id) {
            const [err, res] = await contractorApi.createOnSiteDisposalPlan(this.contractorId, {
              body: this.addSituationSolutionForm,
            })
            if (!err) {
              this.$message.success('保存成功')
              this.cancel()
            }
          } else {
            const [err, res] = await contractorApi.updateOnSiteDisposalPlan(
              this.contractorId,
              this.saveRow.id,
              {
                body: this.addSituationSolutionForm,
              }
            )
            if (!err) {
              this.$message.success('编辑成功')
              this.cancel()
            }
          }

          this.loading = false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-dragger {
  height: 130px !important;
  width: 440px !important;
  .el-icon-upload {
    margin: 18px 0 16px;
  }
}
</style>
